import { APP_ROUTES } from "enums/APP_ROUTES";
import { NavigateOptions } from "react-router-dom";
import useNavigateTo from "./useNavigateTo";

export default function useNavigateToScripts() {
  const navigateTo = useNavigateTo();

  return (path?: string, options?: NavigateOptions) =>
    navigateTo(APP_ROUTES.SCRIPTS, path, options);
}
